<div class="tooltipDs__cont tooltipDs__cont--{{type}} tooltipDs__cont--{{type}}-{{textAlign}} tooltipDs__cont--{{position}} tooltipDs__cont--{{position}}-{{type}}"
  [style.left]="left + 'px'"
  [style.top]="top + 'px'">
  <ng-container #vcr></ng-container>
</div>

<ng-template #embedRef></ng-template>
